import { FC, SVGAttributes } from "react";
import styled from "styled-components";

// eslint-disable-next-line react/require-default-props
const Loader: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <StyledLoader
      viewBox="-100 -100 1200 1200"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={32}
      height={32}
      {...props}
    >
      <path d="M567 4.4V68c213.4 30.7 378 214.3 378 436 0 243.1-197.8 441-441 441S63 747.1 63 504C63 282.3 227.6 98.8 441 68V4.4C192.8 35.5 0 247.5 0 504c0 277.9 226.1 504 504 504s504-226.1 504-504c0-256.5-192.8-468.5-441-499.6z">
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 505 505"
          to="360 503 503"
          calcMode="spline"
          keyTimes="0; 1"
          keySplines="0.445, 0.050, 0.550, 0.950;"
          repeatCount="indefinite"
        />
      </path>
    </StyledLoader>
  );
};

const StyledLoader = styled.svg`
  display: block;
  margin: 0 auto;
`;

export { Loader };
